module.exports = __webpack_public_path__ + "img/ic_chaofa.fcd76eba.png";